import React from 'react'
import { Ratings as StarRating } from '@sainsburys-tech/bolt'
import { pushEventAndTrack } from '../../../helpers/taggingSerializer'
import { openAccordion } from '../../../helpers/openAccordion'
import { runBVReviewsTrack } from '../../../helpers/bazaarVoiceTracking'

import * as Styled from './ReviewStarRating.styles'
import Ratings from '@/components/Ratings/Ratings'
import { useFeatureFlagContext } from '../../../providers/FeatureFlagContext/FeatureFlagContext'

const ReviewStarRating = ({ overallRating, reviewCount, breadcrumb, partNumber, attributes }) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()
  const hasReviews = reviewCount > 0
  if (!hasReviews) return null

  const trackReviewSummaryClick = () => {
    const element = '#reviews'
    openAccordion(element)
    pushEventAndTrack({
      eventInfo: {
        eventName: 'pdp_reviewStarRating',
        eventAction: 'Reviews Star Rating'
      }
    })
    // BazaarVoice Analytics Tracking
    runBVReviewsTrack(
      'FeaturedEvent',
      { breadcrumb, partNumber, attributes },
      'link',
      'pdp_reviewStarRating',
      'PrimaryRatingSummary'
    )
  }
  if (PDP_V2_FLAG)
    return <Ratings onClickHandler={trackReviewSummaryClick} overallRating={overallRating} reviewCount={reviewCount} />
  return (
    <Styled.StarRatingWrapper itemProp='aggregateRating' itemType='https://schema.org/AggregateRating' itemScope>
      <StarRating
        large
        rating={overallRating}
        onClick={trackReviewSummaryClick}
        position='left'
        message={
          <Styled.ReviewCount data-test='review-count' itemProp='ratingCount'>
            {reviewCount}
          </Styled.ReviewCount>
        }
        style={{ marginBottom: '8px' }}
        data-test='review-stars'
      />
      <meta itemProp='ratingValue' content={overallRating} />
      <meta itemProp='worstRating' content='1' />
      <meta itemProp='bestRating' content='5' />
    </Styled.StarRatingWrapper>
  )
}

export default ReviewStarRating
